/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Intent_BankInputs */

const vi_order_settlement_intent_bank = /** @type {(inputs: Order_Settlement_Intent_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế chốt: Chuyển khoản — chờ tiền về`)
};

/**

* @param {Order_Settlement_Intent_BankInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_intent_bank = /** @type {((inputs?: Order_Settlement_Intent_BankInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Intent_BankInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_intent_bank(inputs)
});